import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";

export function Header({
  title,
  showBack,
}: {
  title: string;
  showBack?: boolean;
}) {
  const navigate = useNavigate();
  const student = useAuthStore((s) => s.session?.student);

  return (
    <header className="flex items-center justify-between bg-indigo-600 px-4 py-3 text-white">
      {showBack ? (
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="text-2xl"
          aria-label="Back"
        >
          ←
        </button>
      ) : (
        <span className="w-6" />
      )}
      <h1 className="text-xl font-extrabold">{title}</h1>
      <span className="text-sm font-bold">{student?.name ?? ""}</span>
    </header>
  );
}
